import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  Button,
  Carousel,
  Image,
  Divider,
  Space,
  Card,
  Spin,
  Modal,
  Typography,
  Tooltip,
} from "../../../../components/common/utils/antd-imports/AntdImports.js";
import BackArrow from "../../../../assests/back-arrow.svg";
import { ReactComponent as Arrow3 } from "../../../../assests/Arrow 3.svg";
import { useMediaQuery } from "react-responsive";
import ShareIcon from "./../../../../components/common/reusable-svg-icons/share-icon";
import EyeIcon from "../../../../components/common/reusable-svg-icons/eye-icon.js";
import StackedDollarIcon from "../../../../components/common/reusable-svg-icons/stacked-dollar.js";
import TimerDollarIcon from "../../../../components/common/reusable-svg-icons/timer-dollar.js";
import "./../../../../../src/main.css";
import "./CampaignDetailPage.css";
import { useNavigate, useParams } from "react-router-dom";
import CampaignDetailsIO from "../../../../components/common/io/CampaignDetailsIO";

import { ReactComponent as DownloadIcon } from "../../../../assests/download-icon.svg";
import { ReactComponent as CancelIcon } from "../../../../assests/cancel-icon.svg";
import { ReactComponent as ExcelIcon } from "../../../../assests/export-excel-icon.svg";
import CampaignDetailsQuote from "../../../../components/common/quote/CampaignDetailsQuote";
import { API_BASE_URL_IMAGE } from "./../../../../services/common";
import dayjs from "dayjs";
import ShareCampaign from "../../../../components/modal/share-campaign-modal/ShareCampaign.js";
import OfferCommentsModal from "../../modals/offer-comments-modal/OfferCommentsModal";
import {
  formatBillboardSize,
  formatToUSCurrency,
  handleCopy,
} from "../../../../components/common/utils/Utils.js";

import {
  downloadInsertionOrder,
  downloadQuote,
  getDownloadSigned,
} from "../../../../store/thunks/common-thunks/commonThunk.js";
import {
  getOfferDetails,
  initiateSign,
  viewCampaignDetails,
} from "../../../../store/thunks/seller-thunks/SellerThunk.js";
import ViewTermsPlan from "../../../../components/modal/view-payment-terms/ViewTermsPlan.js";
import BreadcrumbNav from "../../../../components/common/bread-crumbs/BreadCrumb.js";
import { CopyOutlined, SignatureOutlined } from "@ant-design/icons";
import ExportExcel from "../../../../components/modal/export-excel-modal/ExportExcel.js";

const { Title, Text } = Typography;

const CampaignDetailPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isMobileTab = useMediaQuery({ minWidth: 431, maxWidth: 768 });
  const isSmallDevice = useMediaQuery({ maxWidth: 430 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  let { campaignId } = useParams();
  if (campaignId) campaignId = atob(campaignId);

  const {
    isLoading,
    id,
    cid,
    name,
    startDate,
    endDate,
    offerList,
    totalamount,
    total_paid,
    referred_by,
    offercpmval,
    ioPdf,
    quotePdf,
    products,
    status,
    campaign_terms_array,
    percentagevalue,
    tax_percentage_amount_sum,
    gross_fee_price,
    install_production_cost_sum,
    newprocessingfeeamtSum,
    impressionSum,
    campaign_cpmval,
    act_budget,
    buyer_user_address,
    buyer_by_name,
    buyer_user_attn,
    buyer_user_email,
    buyer_user_name,
    org_name,
    offer_comments,
    sponsor_yes_no,
    offer_individual_comments,
    products_in_campaign,
    docusign_signed_pdf_path,
    buyer_signature_path,
    payment_status,
  } = useSelector((state) => state.sellerCampaigns);
  const { user } = useSelector((state) => {
    const userProfile = state.userprofile;
    return {
      ...userProfile,
    };
  });

  const [shareCampaignModal, setShareCampaignModal] = useState(false);
  const [offerCommentsModal, setOfferCommentsModal] = useState(false);
  const [viewTermsModal, setViewTermsModal] = useState(false);
  const [selectedId, setSelectedId] = useState(campaignId);
  const [openDialog, setOpenDialog] = useState(false);
  const [isQuote, setIsQuote] = useState(false);
  const [ioPrint, setIoPrint] = useState(false);
  const [dynamicId, setDynamicId] = useState("");
  const [exportColumnsModal, setExportColumnsModal] = useState(false);
  const downloadIOText = isMobile
    ? "Download Docusign"
    : "Download Docusigned IO PDf";
  const handleCarouselChange = (currentSlide) => { };
  const contentStyle = {
    margin: isMobile || isTablet ? "0" : "0 32px 0 32px",
    height: "182px",
    padding: isMobile || isTablet ? "0" : "19px 26px",
    color: "#fff",
    borderRadius: "10px",
    background: isMobile ? "#fff" : "#F5F5F5",
  };
  const getIconSize = () => {
    if (isMobileTab) return 25;
    else if (isSmallDevice) return 25;
    else return 30;
  };
  const navigate = useNavigate();
  const getClientName = () => {
    return org_name ? org_name : "N/A";
  };
  const getReferredBy = () => {
    return referred_by ? referred_by : "N/A";
  };
  const openShareCampaignModal = () => {
    setSelectedId(campaignId);
    setShareCampaignModal(true);
  };
  const openOfferCommentsModal = (offerId) => {
    setDynamicId(offerId);
    setOfferCommentsModal(true);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(viewCampaignDetails(campaignId));
    dispatch(getOfferDetails(campaignId));
  }, [campaignId]);

  const formatDate = (timestamp) => {
    if (!timestamp) return "Invalid date";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const parts = timestamp.split("-");
    if (parts.length !== 3) return "Invalid date format";
    const [year, month, day] = parts;
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };

  const getPendingAmount = () => {
    let pendingAmount = totalamount - total_paid;
    pendingAmount = pendingAmount ? pendingAmount?.toFixed(2) : 0;
    return formatToUSCurrency(pendingAmount);
  };
  const navigateToExcel = () => {
    sessionStorage.setItem("campaignCid", cid);
    sessionStorage.setItem("campaignProducts", JSON.stringify(products));
    navigate(`/seller/campaigndetails/export-data?_id=${btoa(id)}`);
  };
  useEffect(() => {
    if (isQuote || ioPrint) {
      const pdfBlob = new Blob([isQuote ? quotePdf : ioPdf], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = isQuote ? `Quote-${cid}.pdf` : `IO-${cid}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }, [ioPdf, quotePdf]);

  const handleSignIO = async () => {
    const newTab = window.open("", "_blank");

    newTab.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Preparing Signature</title>
        <style>
          body {
            margin: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: Arial, sans-serif;
          }

          .loader {
            width: 40px;
            height: 40px;
            border: 4px solid #f0f0f0;
            border-top: 4px solid #1677ff;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        </style>
      </head>
      <body>
        <div class="loader"></div>
        <p>Preparing your document for signature...</p>
      </body>
    </html>
  `);

    newTab.document.close();
    const payload = {
      signer_name: user?.name,
      signer_email: user?.email,
      forward_type: 1,
      campaign_id: id,
    };

    try {
      const response = await dispatch(initiateSign(payload)).unwrap();

      if (response?.success && response?.signingUrl) {
        newTab.location.href = response.signingUrl;
        localStorage.setItem("docusignCampaignEnvelopeId", response.envelopeId);
      } else {
        newTab.close();
      }
    } catch (error) {
      newTab.close();
      console.error("Initiate sign error:", error);
    }
  };
  return (
    <>
      <div className="common-container">
        <>
          <div className="bread-crumb-placement">
            <BreadcrumbNav />
          </div>
          <div>
            <Row gutter={24} wrap className="view-campaigns-details-header">
              <Col span={16}>
                <h1 className="campaign  my-campaign main-title-size">
                  {!isMobile && (
                    <Image
                      className="arrow-align pointer"
                      src={BackArrow}
                      preview={false}
                      onClick={() => navigate(-1)}
                    />
                  )}
                  Campaign Details{" "}
                </h1>
              </Col>
              <Col span={8} style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  className="campaign-export-btn"
                  onClick={() =>
                    isMobile ? navigateToExcel() : setExportColumnsModal(true)
                  }
                >
                  {isMobile ? (
                    <Text className="excel-export">Export</Text>
                  ) : (
                    <Text className="excel-export">Export to Excel</Text>
                  )}
                  <ExcelIcon width={"26px"} height={"26px"} />
                </Button>
              </Col>
            </Row>
          </div>
          {!isMobile ? (
            <>
              {!isMobile && <Divider className="no-margin" />}
              <Row className="campaign-detail-cards" style={{ gap: "2%" }}>
                <Col style={{ width: "50%" }}>
                  <Card className="overview-card" title="Campaign Overview">
                    <Space
                      style={{ width: "100%" }}
                      size={10}
                      direction="vertical"
                    >
                      <Row gutter={[2, 5]}>
                        <Col span={isMobile ? 24 : isTablet ? 12 : 7}>
                          <div className="detail-label">Campaign Name</div>
                          <div className="product-copy-text-field">
                            <label className="campaign-name truncate">
                              <Tooltip title={name}> {name} </Tooltip>
                              <CopyOutlined
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent tooltip close
                                  handleCopy(name);
                                }}
                                className="copy-icon"
                              />
                            </label>
                          </div>
                        </Col>
                        <Col span={isMobile ? 24 : isTablet ? 12 : 8}>
                          <div className="detail-label">Campaign ID</div>
                          <div className="product-copy-text-field">
                            <label className="campaign-id ">
                              {cid}{" "}
                              <CopyOutlined
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent tooltip close
                                  handleCopy(cid);
                                }}
                                className="copy-icon"
                              />
                            </label>
                          </div>
                        </Col>

                        <Col span={isMobile ? 24 : isTablet ? 12 : 5}>
                          <div className="detail-label">Client Name</div>
                          <label className="campaign-name">
                            {getClientName()}
                          </label>
                        </Col>
                        <Col span={isMobile ? 24 : isTablet ? 12 : 4}>
                          <div className="detail-label">Referred By</div>
                          <label className="campaign-name">
                            {getReferredBy()}
                          </label>
                        </Col>
                      </Row>

                      <Row gutter={[15, 24]}>
                        <Col span={isMobile ? 24 : isTablet ? 12 : 7}>
                          <div className="detail-label">No. of Products</div>
                          <label className="campaign-name">
                            {products?.length}
                          </label>
                        </Col>
                        <Col span={isMobile ? 24 : isTablet ? 12 : 5}>
                          <div className="detail-label">Contact Number</div>
                        </Col>
                      </Row>

                      <Row gutter={[0, 10]} className="overview-row">
                        <Col
                          className="overview-buttons pointer"
                          span={isTablet ? 12 : 7}
                          onClick={openShareCampaignModal}
                        >
                          <ShareIcon
                            color={"#D2042D"}
                            textColor={"#d2024d"}
                            Text={"Share Campaign"}
                            className="popover-icon share-icon"
                            width={20}
                          />
                        </Col>
                        <Col
                          span={isTablet ? 12 : 7}
                          className="overview-buttons"
                          onClick={() => {
                            setOpenDialog(true);
                            setIoPrint(false);
                            setIsQuote(true);
                          }}
                        >
                          <EyeIcon
                            width={20}
                            textColor={"#D2042D"}
                            color={"#D2042D"}
                            Text={"View Quote"}
                            className="mobile-action-icons mobile-view-icon"
                          />
                        </Col>
                        {products?.[0]?.docusign_sign_status === 1 ? <>
                        </> : (
                          <Col
                            span={isTablet ? 12 : 6}
                            className="overview-buttons"
                            style={{
                              cursor:
                                "pointer"
                              ,
                              display: "flow",
                            }}
                            onClick={
                              handleSignIO
                            }
                          >
                            <SignatureOutlined />
                            <span style={{ marginLeft: "5px" }}>
                              Sign The IO
                            </span>
                          </Col>
                        )}
                        <Col
                          span={isTablet ? 12 : 4}
                          className="overview-buttons"
                          onClick={() => {
                            setOpenDialog(true);
                            setIsQuote(false);
                            setIoPrint(true);
                          }}
                        >
                          <EyeIcon
                            width={20}
                            color={"#D2042D"}
                            textColor={"#D2042D"}
                            Text={"View IO"}
                            className="mobile-action-icons mobile-view-icon"
                          />
                        </Col>

                        {/* {status > 100 && campaign_terms_array?.length > 0 && (
                          <Col
                            span={isTablet ? 12 : 4}
                            className="overview-buttons"
                            onClick={() => {
                              setViewTermsModal(true);
                            }}
                          >
                            <EyeIcon
                              width={20}
                              color={"#D2042D"}
                              textColor={"#D2042D"}
                              Text={"Terms Plan"}
                              className="mobile-action-icons mobile-view-icon"
                            />
                          </Col>
                        )} */}
                        {/* <Col className="overview-buttons signature-action"
                          style={{
                            cursor: campaign_terms_array?.[0]?.payment_status === 2 ? 'pointer' : 'not-allowed',
                            opacity: campaign_terms_array?.[0]?.payment_status === 2 ? 1 : 0.5,
                            pointerEvents: campaign_terms_array?.[0]?.payment_status === 2 ? 'auto' : 'none',
                          }}
                          onClick={campaign_terms_array?.[0]?.payment_status === 2 ? handleSignIO : undefined}
                        >
                          <SignatureOutlined />
                          <span>Sign The IO</span>
                        </Col> */}
                      </Row>
                    </Space>
                  </Card>
                </Col>

                <Col style={{ width: "20%" }} className="amount-group">
                  <Card className="amount-card total-amount-card" title="  ">
                    <span className="amount-content">
                      <StackedDollarIcon
                        className="total-amount-icon action-item"
                        width={getIconSize()}
                        height={
                          isSmallDevice ? "18" : isMobileTab ? "20" : "30"
                        }
                      />
                      <div className="input-values">
                        <span className="amount-label">Total Amount</span>
                        <span className="amount-quantity">
                          {formatToUSCurrency(totalamount?.toFixed(2) ?? 0)}
                        </span>
                      </div>
                    </span>
                  </Card>
                  <Card className="amount-card pending-amount-card" title="  ">
                    <span className="amount-content">
                      <TimerDollarIcon
                        className="action-icons action-item"
                        width={getIconSize()}
                      />
                      <div className="input-values">
                        <span className="amount-label">Pending Amount</span>
                        <span className="amount-quantity">
                          {getPendingAmount()}
                        </span>
                      </div>
                    </span>
                  </Card>
                </Col>

                <Col style={{ width: "26%" }}>
                  <Card className="offer-card -card" title={""}>
                    {offerList?.length > 0 ? (
                      <Carousel
                        arrows
                        afterChange={handleCarouselChange}
                        infinite={false}
                      >
                        {offerList?.map((offer, offerIndex) => (
                          <div key={offerIndex}>
                            <>
                              <div className="offer-title">
                                <h1 className="mobile-offer-header">
                                  Offer Details{" "}
                                </h1>
                                <Button className="status-btn">
                                  {offer.message?.includes("accepted")
                                    ? "Accepted"
                                    : "Rejected"}
                                </Button>
                              </div>
                              <div style={contentStyle}>
                                <Row style={{ height: "50%" }}>
                                  <Col
                                    span={isTablet ? 24 : 12}
                                    style={{ marginBottom: "1.5rem" }}
                                  >
                                    Offer Price
                                    <Row className="prices">
                                      {formatToUSCurrency(
                                        Number(offer?.price).toFixed(2),
                                      )}
                                    </Row>
                                  </Col>
                                  <Col span={isTablet ? 24 : 12}>
                                    Impression Total
                                    <Row className="prices">
                                      {impressionSum}{" "}
                                    </Row>
                                  </Col>
                                  <Col span={isTablet ? 24 : 12}>
                                    CPM total
                                    <Row className="prices">
                                      {formatToUSCurrency(
                                        Number(offercpmval || 0)?.toFixed(2),
                                      )}
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                              <div
                                className="comments-text card-comments"
                                onClick={() => openOfferCommentsModal(offer.id)}
                              >
                                View Comments
                              </div>
                            </>
                          </div>
                        ))}
                      </Carousel>
                    ) : (
                      <Carousel
                        arrows
                        afterChange={handleCarouselChange}
                        infinite={false}
                      >
                        <div>
                          <>
                            <div className="offer-title">
                              <h1 className="mobile-offer-header">
                                Offer Details{" "}
                              </h1>
                            </div>
                            <div style={contentStyle}>
                              <Row className="mobile-offer-header-row">
                                <h3 className="mobile-offer-header">
                                  {" "}
                                  No Offers available
                                </h3>
                              </Row>
                            </div>
                            <div className="comments-text card-comments">
                              No Comments
                            </div>
                          </>
                        </div>
                      </Carousel>
                    )}
                  </Card>
                </Col>
              </Row>
              <h1 className="product-header">Product Details</h1>
              {products && products?.length > 0 ? (
                products?.map((product) => (
                  <Card
                    className="campaign-product-card"
                    style={{ marginBottom: "24px" }}
                  >
                    <Row className="product-row" gutter={30}>
                      {/* Image section */}
                      <Col
                        span={isTablet ? 5 : 3}
                        className="product-align image-section"
                      >
                        <Image
                          className="product-align-image"
                          src={`${API_BASE_URL_IMAGE}` + product?.image[0]}
                          preview={false}
                        />
                      </Col>

                      {/* Campaign Detail fields */}
                      <Col span={17}>
                        <Row gutter={[20, 20]}>
                          <Col
                            span={6}
                            className="product-label siteNumber ellipsis-textoverflow"
                          >
                            <div className="product-copy-text-field">
                              <span className="campaign-id ">
                                {product.siteNo}{" "}
                                <CopyOutlined
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent tooltip close
                                    handleCopy(product.siteNo);
                                  }}
                                  className="copy-icon"
                                />
                              </span>
                            </div>

                            <div
                              className="siteName ellipsis-textoverflow"
                              style={{ display: "block" }}
                            >
                              <Tooltip
                                styles={{
                                  body: {
                                    color: "#fff",
                                    backgroundColor: "#000",
                                  },
                                }}
                                title={
                                  <pre style={{ margin: 0, textWrap: "auto" }}>
                                    {product?.title}
                                  </pre>
                                }
                              >
                                <div className="product-copy-text-field">
                                  <Text
                                    className="product-title truncate"
                                    strong
                                  >
                                    {product?.title}
                                  </Text>
                                  <CopyOutlined
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent tooltip close
                                      handleCopy(product?.title);
                                    }}
                                    className="copy-icon"
                                  />
                                </div>
                              </Tooltip>
                            </div>
                          </Col>

                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label">Size </div>
                            <div className="prices">
                              {formatBillboardSize(product?.width)} X{" "}
                              {formatBillboardSize(product?.height)}
                            </div>
                          </Col>
                          <Col span={isTablet ? 6 : 4}>
                            <div className="product-label">Impressions</div>
                            <div className="prices">
                              {product?.impressionsperselectedDates?.toFixed(2)}
                            </div>
                          </Col>
                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label">Product Price</div>
                            <div className="prices">
                              {formatToUSCurrency(
                                Number(product?.price)?.toFixed(2),
                              )}
                            </div>
                          </Col>
                          <Col span={isTablet ? 6 : 4}></Col>

                          <Col span={6}>
                            <div className="product-label">Location</div>
                            <div className="prices">{product?.address}</div>
                          </Col>
                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label"> Media Type</div>
                            <div className="prices">{product?.type}</div>
                          </Col>

                          <Col span={isTablet ? 6 : 4}>
                            <div className="product-label"> CPM</div>
                            <div className="prices">
                              <span>
                                {(product?.cpm ||
                                  product?.cpm !== "NaN" ||
                                  product?.cpm !== "") &&
                                  formatToUSCurrency(
                                    Number(product?.cpm)?.toFixed(2),
                                  )}
                              </span>
                            </div>
                          </Col>

                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label">
                              Tax({parseFloat(product?.tax_percentage || 0)}%)
                            </div>
                            <div className="prices">
                              <span>$</span>
                              {product?.tax_percentage_amount}
                            </div>
                          </Col>

                          <Col span={isTablet ? 6 : 4}>
                            <div className="product-label"> Quantity</div>
                            <div className="prices">{product?.quantity}</div>
                          </Col>
                          <Col span={6}>
                            <div className="product-label">Facing</div>
                            <div className="prices">{product?.direction}</div>
                          </Col>
                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label"> Selected Dates</div>
                            <div className="prices">
                              {formatDate(product?.booked_from)}
                              <Arrow3 className="prices-image" />
                              {formatDate(product?.booked_to)}
                            </div>
                          </Col>
                          <Col span={isTablet ? 6 : 4}>
                            <div className="campaign-overview-header">
                              Selected Days
                            </div>
                            <span className="prices" level={5}>
                              {`${Math.floor(
                                (new Date(product?.booked_to).setHours(
                                  0,
                                  0,
                                  0,
                                  0,
                                ) -
                                  new Date(product?.booked_from).setHours(
                                    0,
                                    0,
                                    0,
                                    0,
                                  )) /
                                (1000 * 60 * 60 * 24),
                              ) + 1
                                } Days`}
                            </span>
                          </Col>
                          <Col span={isTablet ? 6 : 5}>
                            <div className="product-label">
                              {" "}
                              Installation Fees + Production Price
                            </div>
                            <div className="prices">
                              {`${formatToUSCurrency(
                                parseFloat(
                                  product?.install_cost_price || 0,
                                ).toFixed(2),
                              )} + ${formatToUSCurrency(
                                Number(product?.production_cost_price).toFixed(
                                  2,
                                ),
                              )}`}
                            </div>
                          </Col>

                          {isTablet && (
                            <>
                              <Col>
                                <span className="product-label">
                                  Total Price{" "}
                                </span>
                                <span className="total-price">
                                  {formatToUSCurrency(
                                    product?.offerpriceperselectedDates?.toFixed(
                                      2,
                                    ),
                                  )}
                                </span>{" "}
                              </Col>
                            </>
                          )}
                        </Row>
                      </Col>

                      {!isTablet && (
                        <Col span={3}>
                          <Space direction="vertical" size={74}>
                            <Row span={4}>
                              <Col className="product-label">
                                Total Price{" "}
                                <div className="total-price-val">
                                  {formatToUSCurrency(
                                    product?.offerpriceperselectedDates?.toFixed(
                                      2,
                                    ),
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </Space>
                        </Col>
                      )}
                    </Row>
                  </Card>
                ))
              ) : (
                <div style={{ marginTop: "3rem" }}>
                  <Row align="middle" justify="center">
                    <span className="produuct-nill-tag">
                      No products have been added yet. Start building your
                      campaign to make an impact!
                    </span>
                  </Row>
                </div>
              )}
            </>
          ) : (
            <>
              <Card className="mobile-campaign-detail-card">
                <Row gutter={22}>
                  <Col span={24} className="campaign-values">
                    <div className="campaign-id-sub-fields text-color">
                      {cid}
                    </div>
                    <div className="campaign-name">{name}</div>
                  </Col>
                  <Col span={24} className="campaign-values campaign-inputs">
                    <div className="detail-label field-text-size">
                      No. of Products
                    </div>
                    <label className="field-text-size">
                      {products?.length}
                    </label>
                  </Col>
                  <Col span={24} className="campaign-values campaign-inputs">
                    <div className="detail-label field-text-size">
                      Client Name
                    </div>
                    <label className="field-text-size">-</label>
                  </Col>
                  <Col className="campaign-values campaign-inputs" span={12}>
                    <div className="detail-label field-text-size">
                      Contact Number
                    </div>
                  </Col>
                  <Col span={12} className="campaign-values campaign-inputs">
                    <div className="detail-label field-text-size">
                      Referred By
                    </div>
                    <label className="field-text-size">{getReferredBy()}</label>
                  </Col>
                </Row>
              </Card>
              <Row
                gutter={isMobile ? [10, 10] : [24, 24]}
                className="campaign-more-actions-div actions-container actions-container-row"
              >
                <Col
                  className="campaign-amount-container"
                  span={isMobile ? 6 : 7}
                >
                  <span
                    className="campaign-more-actions"
                    onClick={openShareCampaignModal}
                  >
                    <ShareIcon
                      height={22}
                      width={22}
                      color={"#D2042D"}
                      flexDirection={"column"}
                      className="mobile-action-icons mobile-view-icon"
                    />
                    <span className="campaign-more-actions-text">
                      Share Campaigns
                    </span>
                  </span>
                </Col>
                <Col
                  className="campaign-amount-container"
                  span={isMobile ? 6 : 7}
                >
                  <div
                    className="campaign-more-actions"
                    onClick={() => {
                      setOpenDialog(true);
                      setIsQuote(false);
                      setIoPrint(true);
                    }}
                  >
                    <EyeIcon
                      height={24}
                      width={24}
                      flexDirection={"column"}
                      textColor={"#000"}
                      color={"#D2042D"}
                      Text={"View IO"}
                      className="mobile-action-icons mobile-view-icon"
                    />
                  </div>
                </Col>
                <Col
                  className="campaign-amount-container"
                  span={isMobile ? 6 : 7}
                >
                  <div
                    className="campaign-more-actions"
                    onClick={() => {
                      setOpenDialog(true);
                      setIsQuote(true);
                      setIoPrint(false);
                    }}
                  >
                    <EyeIcon
                      height={24}
                      width={24}
                      flexDirection={"column"}
                      textColor={"#000"}
                      color={"#D2042D"}
                      Text={"View Quote"}
                      className="mobile-action-icons mobile-view-icon"
                    />
                  </div>
                </Col>
                {/* <Col span={6}></Col> */}
                {/* {status > 100 && campaign_terms_array?.length > 0 && (
                  <Col
                    className="campaign-more-actions-container terms-section"
                    span={5}
                    onClick={() => {
                      setViewTermsModal(true);
                    }}
                  >
                    <div className="campaign-more-actions">
                      <EyeIcon
                        height={24}
                        width={24}
                        flexDirection={"column"}
                        textColor={"#000"}
                        color={"#D2042D"}
                        Text={"Terms Plan"}
                        className="mobile-action-icons mobile-view-icon"
                      />
                    </div>
                  </Col>
                )} */}
              </Row>
              <Row className="campaign-details-page-row-css">
                <Col
                  className="campaign-more-actions-container"
                  span={11}
                  style={{ height: "100px" }}
                >
                  <div className="campaign-overview-total-amount">
                    <div>
                      <StackedDollarIcon
                        className="total-amount-icon action-item"
                        width={getIconSize()}
                        height={getIconSize()}
                      />
                    </div>
                    <div className="campaign-details-page-alignment">
                      <span className="campaign-amount-header">
                        Total Amount
                      </span>
                      <span className="campaign-overview-common-css">
                        {formatToUSCurrency(totalamount?.toFixed(2))}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col className="prices-container" span={11}>
                  <div>
                    <div className="campaign-overview-total-amount">
                      <div>
                        <TimerDollarIcon
                          className="action-item"
                          width={getIconSize()}
                          height={getIconSize()}
                        />
                      </div>
                      <div className="campaign-details-page-alignment">
                        <span className="campaign-amount-header">
                          Pending Amount
                        </span>
                        <span className="campaign-overview-common-css">
                          {getPendingAmount()}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Col
                span={22}
                style={{ marginTop: "20px" }}
                className="offers-carousel"
              >
                <Card>
                  {offerList?.length > 0 ? (
                    <>
                      <Carousel
                        arrows
                        className="offer-card mobile-offer-card"
                        afterChange={handleCarouselChange}
                        infinite={false}
                      >
                        {offerList?.map((offer, offerIndex) => (
                          <div
                            key={offerIndex}
                            id={offerIndex}
                            className="offer-content"
                          >
                            <>
                              <div className="offer-title">
                                <span className="mobile-offer-header">
                                  Offer Details{" "}
                                </span>
                                <Button className="status-btn">
                                  {offer.message?.includes("accepted")
                                    ? "Accepted"
                                    : "Rejected"}
                                </Button>
                              </div>
                              <div style={contentStyle}>
                                <span className="offer-number">
                                  Offer {offerIndex + 1}
                                </span>
                                <Row style={{ height: "25%" }} gutter={[0, 15]}>
                                  <Col span={12} className="detail-label">
                                    Offer Price
                                    <Row className="campaign-name">
                                      {formatToUSCurrency(
                                        Number(offer?.price).toFixed(2),
                                      )}
                                    </Row>
                                  </Col>
                                  <Col span={12} className="detail-label">
                                    {" "}
                                    Impression Total
                                    <Row className="campaign-name">
                                      {impressionSum}{" "}
                                    </Row>
                                  </Col>
                                  <Col span={12} className="detail-label">
                                    CPM Total
                                    <Row className="campaign-name">
                                      {formatToUSCurrency(
                                        offercpmval?.toFixed(2),
                                      )}{" "}
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                            </>
                          </div>
                        ))}
                      </Carousel>
                      <div className="comments-text card-comments">
                        View Comments
                      </div>
                    </>
                  ) : (
                    <Carousel
                      arrows
                      afterChange={handleCarouselChange}
                      infinite={false}
                    >
                      <div>
                        <>
                          <div className="offer-title">
                            <h1 className="mobile-offer-header">
                              Offer Details{" "}
                            </h1>
                          </div>
                          <div style={contentStyle}>
                            <Row className="mobile-offer-header-row">
                              <h3 className="mobile-offer-header">
                                {" "}
                                No Offers available
                              </h3>
                            </Row>
                          </div>
                          <div className="comments-text card-comments">
                            No Comments
                          </div>
                        </>
                      </div>
                    </Carousel>
                  )}
                </Card>
              </Col>
              <Col className="product-details">
                <h1 className="detail-header">Product Details</h1>
                {products?.map((product) => (
                  <Card
                    className="campaign-product-card"
                    style={{ marginBottom: "24px" }}
                  >
                    <Row gutter={24}>
                      <Col span={8} className="product-align">
                        <Image
                          src={`${API_BASE_URL_IMAGE}` + product?.image[0]}
                          style={{ marginRight: "39px" }}
                          preview={false}
                        />
                      </Col>
                      <Col span={16}>
                        <div
                          style={{ display: "block", color: "#d2042d" }}
                          className="campaign-id-sub-fields "
                        >
                          {product.siteNo}
                          <div span={24} className="prices">
                            {product.title}{" "}
                          </div>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Location
                        </div>
                        <Title className="billboard-values" level={5}>
                          {product.address}
                        </Title>
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Media Type
                        </div>
                        <Title className="billboard-values" level={5}>
                          {product?.type}
                        </Title>
                      </Col>
                      <Col span={24}>
                        <div className="product-label field-text-size">
                          {" "}
                          Selected Dates
                        </div>
                        <Title className="billboard-values" level={5}>
                          <span>{formatDate(product?.booked_from)}</span>
                          <Arrow3 className="dates-image" />
                          {formatDate(product?.booked_to)}
                        </Title>
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Selected Days
                        </div>
                        <Title className="billboard-values" level={5}>
                          {`${Math.floor(
                            (new Date(product?.booked_to).setUTCHours(
                              0,
                              0,
                              0,
                              0,
                            ) -
                              new Date(product?.booked_from).setUTCHours(
                                0,
                                0,
                                0,
                                0,
                              )) /
                            (1000 * 60 * 60 * 24),
                          ) + 1
                            } Days`}
                        </Title>{" "}
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          Facing
                        </div>
                        <Title className="billboard-values" level={5}>
                          {product?.direction}
                        </Title>
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Size
                        </div>
                        <Title className="billboard-values" level={5}>
                          {formatBillboardSize(product.panelSize)}
                        </Title>
                      </Col>

                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Impressions
                        </div>
                        <Title className="billboard-values" level={5}>
                          {product.impressionsperselectedDates?.toFixed(2)}
                        </Title>
                      </Col>

                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          CPM
                        </div>
                        <Title className="billboard-values" level={5}>
                          {formatToUSCurrency(Number(product?.cpm)?.toFixed(2))}
                        </Title>
                      </Col>

                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Product Price
                        </div>
                        <Title className="billboard-values" level={5}>
                          {formatToUSCurrency(product.price?.toFixed(2))}
                        </Title>
                      </Col>
                      <Col span={12}>
                        <div className="product-label field-text-size">
                          {" "}
                          Tax({parseFloat(product?.tax_percentage || 0)}%)
                        </div>
                        <Title className="billboard-values" level={5}>
                          <span>$</span>
                          {product.tax_percentage_amount}
                        </Title>
                      </Col>

                      <Col span={24}>
                        <div className="product-label">
                          Installation + Production
                        </div>

                        <Title className="billboard-values" level={5}>
                          {`${formatToUSCurrency(
                            parseFloat(
                              product?.install_cost_price || 0,
                            ).toFixed(2),
                          )} + ${formatToUSCurrency(
                            Number(product?.production_cost_price).toFixed(2),
                          )}`}
                        </Title>
                      </Col>
                      <Divider />
                      <Row className="product-label-row">
                        <Col span={12}>
                          <div className="product-label"> Quantity</div>

                          <Title className="billboard-values" level={5}>
                            {product.quantity}
                          </Title>
                        </Col>
                        <Col span={12}>
                          <div className="total-price-group">
                            <span className="product-label">Total Price</span>
                            <div className="total-price-val">
                              {formatToUSCurrency(
                                product.offerpriceperselectedDates?.toFixed(2),
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </Card>
                ))}
              </Col>
            </>
          )}
        </>

        <Modal
          open={shareCampaignModal}
          footer={false}
          width={558}
          height={469}
          closable={false}
          centered
        >
          <ShareCampaign
            shareCampaign={shareCampaignModal}
            setShareCampaign={setShareCampaignModal}
            campaignId={selectedId}
          />
        </Modal>

        {offerCommentsModal && (
          <OfferCommentsModal
            offerCommentsModal={offerCommentsModal}
            setOfferCommentsModal={setOfferCommentsModal}
            dynamicId={dynamicId}
          />
        )}
        {viewTermsModal && (
          <ViewTermsPlan
            campaignTermsArray={campaign_terms_array}
            setViewTermsModal={setViewTermsModal}
            viewTermsModal={viewTermsModal}
          />
        )}
      </div>
      <Modal
        className="view-io"
        title={
          <div className="view-io-title">
            <>
              <span className="view-io-title-content">
                {isQuote ? "View Quote" : "Insertion Order (IO)"}
              </span>
            </>
            <div className="view-io-div">
              <div
                className="view-io-download-div"
                onClick={() => {
                  isQuote
                    ? dispatch(downloadQuote(campaignId))
                    : products?.[0]?.docusign_sign_status === 1
                      ? dispatch(
                        getDownloadSigned({
                          envelope_id: products?.[0]?.envelope_id,
                        }),
                      )
                      : dispatch(downloadInsertionOrder(campaignId));
                }}
              >
                <DownloadIcon color="#fff" />
                <span style={{ color: "#fff" }}>
                  {isQuote ? "Download Quote PDF" : downloadIOText}
                </span>
              </div>
              <div
                className="view-io-cancel-icon"
                onClick={() => setOpenDialog(false)}
              >
                <CancelIcon />
              </div>
            </div>
          </div>
        }
        centered
        open={openDialog}
        onOk={() => setOpenDialog(false)}
        onCancel={() => setOpenDialog(false)}
        footer={<></>}
        closeIcon={<></>}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "40%",
        }}
      >
        {isQuote ? (
          <CampaignDetailsQuote
            pdfLoader={isLoading}
            campaignDetails={{
              id: cid,
              campaignId: id,
              name,
              startDate,
              endDate,
              totalDays:
                endDate &&
                startDate &&
                dayjs(endDate, "DD-MM-YYYY").diff(
                  dayjs(startDate, "DD-MM-YYYY"),
                  "day",
                ),
              percentagevalue,
              tax_percentage_amount_sum,
              gross_fee_price,
              install_production_cost_sum,
              totalamount,
              newprocessingfeeamtSum,
              impressionSum,
              campaign_cpmval,
              act_budget,
              products,
            }}
          />
        ) : (
          <CampaignDetailsIO
            pdfLoader={isLoading}
            campaignDetails={{
              id: cid,
              campaignId: id,
              name,
              startDate,
              endDate,
              status,
              totalDays:
                endDate &&
                startDate &&
                dayjs(endDate, "DD-MM-YYYY").diff(
                  dayjs(startDate, "DD-MM-YYYY"),
                  "day",
                ),
              percentagevalue,
              tax_percentage_amount_sum,
              gross_fee_price,
              install_production_cost_sum,
              totalamount,
              newprocessingfeeamtSum,
              buyer_user_address,
              buyer_by_name,
              buyer_user_attn,
              buyer_user_email,
              buyer_user_name,
              offer_comments,
              offer_individual_comments,
              sponsor_yes_no,
              products,
              products_in_campaign,
              docusign_signed_pdf_path,
              buyer_signature_path,
              campaign_terms_array,
            }}
          />
        )}
      </Modal>
      {exportColumnsModal && (
        <ExportExcel
          exportColumnsModal={exportColumnsModal}
          setExportColumnsModal={setExportColumnsModal}
          campaignId={cid}
          campaignProducts={products}
        />
      )}

      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default CampaignDetailPage;
